export const en = {
  message: 'Hello World'
}



// WEBPACK FOOTER //
// ./src/lang/en.js